module.exports = __webpack_public_path__ + "img/branding-logo-white.8a96d040.svg";